/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

const getObjectById = (objects_, id_) => {
    if (Array.isArray(objects_)) {
        for (let i = 0, length = objects_.length; i < length; i++) {
            if (objects_[i]) {
                if (id_ === objects_[i].id) {
                    return objects_[i];
                }
            }
        }
    }
    return null;
};

export default getObjectById;
